import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Box, BoxTitle, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

export default class Piastrix extends Base {
	getStep1(translate) {
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					<Fragment>
						<FormItem
							onRegister={() => this.registerField({ name: "piastrixAccount" })}>
							<Box>
								<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									type="number"
									onChange={this.onEnterValue.bind(this, "piastrixAccount")}
								/>
							</Box>
						</FormItem>
					</Fragment>
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, piastrixAccount, selectedCurrency } = this.state;
		let withdrawData = {
			piastrixAccount,
			type: "Piastrix",
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			username: getUser().username,
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
